/* eslint-disable no-console */
import { ModalBody } from './styles';

import Icon from '@icons';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const onClose = () => {
  ReactDOM.render(null, document.getElementById('alert'));
};

const ModalImage = ({
  imageUrl,  
  callback,   
}) => {
  const closeAndCallback = (boolean) => {
    if ((boolean === true || typeof boolean === 'undefined') && callback && typeof callback === 'function') {
      callback(boolean === true);
    }

    onClose();
  };

  return (
    <ModalBody 
      style={{ zIndex: 2050 }} 
      onClick={(e) => {        
        if (e.target === e.currentTarget) closeAndCallback()
      }}
    >
      <div className="modalBox">
        <div className="container-img">
          <div className="container-buttons">
            <button onClick={closeAndCallback} className="minimize">
              <Icon i="all-minimizeImageModal" />
            </button>             
            <button onClick={() => closeAndCallback(true)} className="close">
              <Icon i="all-closeImageModal" />
            </button>        
          </div>
          <img src={imageUrl} alt="Imagem" style={{ maxWidth: "1024px", maxHeight: "768px" }} ></img>
        </div>
      </div>
    </ModalBody>
  );
};

ModalImage.propTypes = {  
  imageUrl: PropTypes.string,
  callback: PropTypes.func,  
};

export default ModalImage;
